import React from 'react'
import styled from 'styled-components'
import TocList from './tocList'
import { IoIosMenu } from 'react-icons/io'

import { MdClose } from 'react-icons/md'

const StyledMenu = styled.div`
  svg {
    height: 30px;
    width: 30px;
  }

  svg:hover {
    cursor: pointer;
  }

`

const StyledToc = styled.nav`
  color: black !important;

  position: absolute;
  top: 0; left:0;
  background-color: rgba(255,255,255,1);
  
  height: 100vh;
  width: 100vw;

  overflow-y: scroll;


  @media only screen and (min-width: 800px) {
    max-width: 40vw;
  }

  transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(-100%)'};
  transition: transform 0.5s, visibility 0.5s;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);

  svg {
    position: absolute;
    left: 25px;
    top: 21px;
    color: black;
  }
  
  ul {
    text-align: left;    
    margin: 50px 30px;
    list-style-type: none;
  }

  }
`;

const Menu = ({ onHideNav, onShowNav, showNav }) => (
  <StyledMenu>
    <IoIosMenu onClick={showNav ? onHideNav : onShowNav} />
    <StyledToc open={showNav}>
      <MdClose onClick={onHideNav} />
      <TocList className="list" />
    </StyledToc>
  </StyledMenu>
)

export default Menu